import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Option } from '@euler/model';
import { CustomerType } from '@euler/model/enum';
import { memo } from 'react';
import { Path, Svg } from 'react-native-svg';
import { useOrderFlowContext } from '../../../../OrderFlowContext';
import { IconWrapper } from '../components/IconWrapper';
import InlineRadios from '../components/InlineRadios';
import { Row } from '../components/Row';
import { RowErrorText } from '../components/RowErrorText';

const kOptions: Option<CustomerType>[] = [
  { value: CustomerType.Default, text: '私家车' },
  {
    value: CustomerType.Official,
    text: '公务/单位车',
  },
];

export const CustomerTypeRow = memo(
  ({ required, ...props }: { required?: boolean; disabled?: boolean }) => {
    const {
      theme,
      formController: { form },
    } = useOrderFlowContext();

    const { iconColor } = theme;

    return (
      <Row
        errorProp="customerType"
        note={<RowErrorText error={form.customerType.error} />}
        required={required}
        title="客户类型"
        icon={
          <IconWrapper>
            <RowIcon color={iconColor} />
          </IconWrapper>
        }
        detail={
          <InlineRadios
            options={kOptions}
            value={form.customerType.value}
            disabled={props.disabled}
            onChange={form.customerType.update}
          />
        }
        {...props}
      />
    );
  },
);

export const RowIcon = memo(
  ({ size, color = '#207FE7', style, ...props }: IconProps) => {
    const { rpx } = useResponsiveContext();
    return (
      <Svg
        viewBox="0 0 1024 1024"
        width={size ?? rpx(20)}
        height={size ?? rpx(20)}
        style={style}
        {...props}
      >
        <Path
          d="M853.333333 170.666667H170.666667c-46.933333 0-85.333333 38.4-85.333334 85.333333v512c0 46.933333 38.4 85.333333 85.333334 85.333333h682.666666c46.933333 0 85.333333-38.4 85.333334-85.333333V256c0-46.933333-38.4-85.333333-85.333334-85.333333zM298.666667 277.333333c59.733333 0 106.666667 46.933333 106.666666 106.666667S358.4 490.666667 298.666667 490.666667 192 443.733333 192 384 238.933333 277.333333 298.666667 277.333333z m512 426.666667c0 12.8-8.533333 21.333333-21.333334 21.333333h-554.666666c-12.8 0-21.333333-8.533333-21.333334-21.333333v-42.666667c0-12.8 8.533333-21.333333 21.333334-21.333333h554.666666c12.8 0 21.333333 8.533333 21.333334 21.333333v42.666667z m0-170.666667c0 12.8-8.533333 21.333333-21.333334 21.333334h-256c-12.8 0-21.333333-8.533333-21.333333-21.333334v-42.666666c0-12.8 8.533333-21.333333 21.333333-21.333334h256c12.8 0 21.333333 8.533333 21.333334 21.333334v42.666666z m0-170.666666c0 12.8-8.533333 21.333333-21.333334 21.333333h-213.333333c-12.8 0-21.333333-8.533333-21.333333-21.333333v-42.666667c0-12.8 8.533333-21.333333 21.333333-21.333333h213.333333c12.8 0 21.333333 8.533333 21.333334 21.333333v42.666667z"
          fill={color}
        />
      </Svg>
    );
  },
);
